const t = {
  fr: {
    // Navbar
    nav: {
      home: 'Accueil',
      courses: 'Formations',
      testimonials: 'Témoignages',
      method: 'Méthode',
      campus: 'Campus',
      login: 'Connexion',
    },
    // Hero
    hero: {
      brandName: 'OPENBRO · GAUT BONAC',
      headline: 'UN MENTOR. UN PLAN. CHAQUE MOIS.',
      subtitle1: 'Un appel privé avec moi <strong>chaque mois</strong>, et tu repars avec tes actions pour les 30 prochains jours.',
      subtitle2: {
        before: 'Entre deux appels, 6 formations pour avancer sur ton ',
        bold1: 'CORPS',
        mid1: ', ton ',
        bold2: 'CONTENU',
        mid2: ' et tes ',
        bold3: 'REVENUS.',
      },
      cta: 'Rejoindre OpenBro',
      enrolled: 'Sans engagement · Résiliable à tout moment',
    },
    // Stats
    stats: [
      { value: '1', label: 'Appel privé par mois' },
      { value: '6', label: 'Formations complètes' },
      { value: '100+', label: 'Leçons' },
    ],
    // Take Action
    takeAction: {
      label: 'PASSE À L’ACTION',
      title: 'Tu N’as Pas Besoin De Plus De Contenu',
      paragraphs: [
        { text: 'Tu as besoin de <strong>quelqu’un qui te dit quoi faire ensuite</strong>, et qui te demande des comptes le mois suivant.' },
        { text: 'Chaque mois, on s’appelle. Tu repars avec <mark>un plan d’action pour 30 jours.</mark>' },
        { text: 'Entre deux appels : musculation, nutrition, e-commerce, tournage, montage, IA. <strong>Tout ce qu’il faut pour exécuter.</strong>' },
        { text: 'Les formations sont données par <strong>des gens qui pratiquent</strong>, pas par des théoriciens.' },
        { text: 'Et une <mark>communauté privée</mark> de gens qui avancent, pour ne plus avancer seul.' },
      ],
    },
    // Campuses
    campuses: {
      label: '6 FORMATIONS INCLUSES',
      title: 'Ce Que Tu Vas Apprendre',
      items: [
        { name: 'Musculation & Discipline', description: 'De zéro à intermédiaire : <strong>technique, programmation, progression.</strong> Et une discipline qui tient au-delà de la salle.' },
        { name: 'E-commerce & Réseaux sociaux', description: '<strong>Lance ta boutique et fais grandir ton audience.</strong> Trouver un produit, vendre, transformer tes abonnés en clients.' },
        { name: 'Tournage', description: 'Filme comme un pro <strong>avec un iPhone.</strong> Cadrage, lumière, son : tout ce qui rend une vidéo regardable.' },
        { name: 'Montage vidéo', description: 'CapCut et au-delà : <strong>rythme, accroches, rendu pro.</strong> Des vidéos qu’on regarde jusqu’au bout.' },
        { name: 'IA & Automatisation', description: '<strong>Utilise l’IA au quotidien</strong> et apprends à vendre des services IA. Gagne du temps, puis de l’argent.' },
        { name: 'Nutrition & Performance', description: 'Alimentation, suppléments et <strong>un système simple à tenir.</strong> Plus d’énergie, une meilleure récupération.' },
      ],
    },
    // Empowering
    empowering: {
      label: 'OPENBRO',
      title: 'Tu N’avances Plus Seul',
      testimonialName: '',
      testimonialEarning: '',
      description: 'Chez OpenBro, tu apprends <strong>les compétences qui comptent vraiment</strong>, avec un appel privé chaque mois et <mark>une communauté de gens qui passent à l’action.</mark>',
    },
    // Features
    features: [
      {
        title: 'La Discipline, C’est La Liberté',
        points: ['Des programmes de musculation et des routines quotidiennes structurées.', 'Le suivi de tes habitudes et de ta série de jours dans ton espace membre.', 'Une nutrition pensée pour la performance, simple à tenir.'],
      },
      {
        title: 'Du Contenu Qui Accroche',
        points: ['Tournage et montage, du script à la publication.', 'Des formats courts qui retiennent dès la première seconde.', 'Monétise ton audience avec l’e-commerce.'],
      },
      {
        title: 'IA & Automatisation',
        points: ['Utilise l’IA pour gagner du temps sur ton business et ton contenu.', 'Apprends à vendre des services IA.', 'Pose tes questions dans la communauté privée.'],
      },
    ],
    // Two Paths
    twoPaths: {
      label: 'CHOISIS TON CHEMIN',
      title: 'Deux Chemins S’offrent À Toi',
      path1: {
        price: '0 €',
        description: 'Tu continues à scroller <strong>sans rien changer.</strong> Même corps, même routine, mêmes résultats. <strong>Le temps passe</strong> et rien ne bouge.',
        cta: 'Rester spectateur',
      },
      path2: {
        price: '49€/mois',
        description: 'Un appel privé chaque mois, <strong>un plan pour 30 jours</strong> et 6 formations pour l’exécuter. Sans engagement, <mark>résiliable à tout moment.</mark>',
        cta: 'Rejoindre OpenBro',
      },
    },
    // Student Wins
    studentWins: {
      label: 'RÉSULTATS MEMBRES',
      title: 'Ils Sont Passés À L’action',
      subtitle: 'Des captures envoyées par des membres.',
      subtitleBold: 'Le plan vient de l’appel. <mark>Le travail vient d’eux.</mark>',
    },
    // Last Chance
    lastChance: {
      title: 'Dans 30 Jours, Tu Seras Quelque Part',
      cta: 'Rejoindre OpenBro',
      subtitle: 'Autant que ce soit avec un plan.',
    },
    // FAQ
    faq: {
      title: 'Questions Fréquentes',
      disclaimer1: 'Tout le contenu enseigné au sein d’OpenBro est à but éducatif. C’est à chaque membre d’appliquer et de fournir le travail nécessaire.',
      disclaimer2: 'OpenBro ne garantit aucun résultat physique ou financier.',
      questions: [
        { question: 'C’est pour qui ?', answer: 'Pour toi si tu veux avancer sur ton business, ton argent, ton corps ou ta vie perso, et que tu es prêt à passer à l’action. Si tu cherches une formule magique, tu l’as trouvée.' },
        { question: 'Comment se passe l’appel ?', answer: 'Tu choisis ton créneau avant de payer. Je t’appelle au numéro indiqué au paiement. On fait le point sur ta situation et tu repars avec tes priorités du mois.' },
        { question: 'Je suis débutant, c’est un problème ?', answer: 'Non. Les formations partent de zéro, et l’appel part de ta situation, pas d’un programme standard.' },
        { question: 'J’ai besoin de matériel ?', answer: 'Non. Les programmes s’adaptent à la salle comme à la maison. Pour la vidéo, un smartphone suffit pour commencer.' },
        { question: 'Combien de temps par jour ?', answer: 'Ça dépend de ton plan. On le cale pendant l’appel sur le temps que tu as vraiment, pas sur celui que tu aimerais avoir.' },
        { question: 'Que se passe-t-il après le paiement ?', answer: 'Tu actives ton compte avec ton prénom et ton email. Tu te connectes avec un code reçu par email, et tu as accès à tout : formations, suivi, communauté.' },
        { question: 'Je peux arrêter quand je veux ?', answer: 'Oui. L’abonnement est sans engagement, tu le résilies quand tu veux. Les mois déjà payés ne sont pas remboursés.' },
        { question: 'Encore une question ?', answer: 'Écris-nous via le chat en bas à droite, ou par email à contact@openroom.com.' },
      ],
    },
    // Custom Platform
    customPlatform: {
      title: 'Ton Espace\\nMembre',
      description: 'Formations, suivi des habitudes et progression, <mark>au même endroit, sur mobile et ordinateur.</mark>',
    },
    // Urgency
    urgency: {
      offer: 'OPENBRO',
      price: '49€/MOIS',
      wontLast: 'UN APPEL PRIVÉ CHAQUE MOIS',
      discount: '6 FORMATIONS',
      priceWillIncrease: 'COMMUNAUTÉ PRIVÉE',
      members: 'SANS ENGAGEMENT · RÉSILIABLE À TOUT MOMENT',
    },
    // Fixed button
    landing: {
      tagline: 'Quelque chose arrive...',
      prompt: 'Entre ton email pour être le premier informé',
      emailPlaceholder: 'tonmeilleur@email.com',
      cta: 'ENTRER',
      sending: '...',
      successMessage: 'Tu es sur la liste.',
      successSub: 'On te contacte bientôt.',
      invalidEmail: 'Email invalide',
      networkError: 'Erreur de connexion',
      footerHint: 'OPENBRO 2025',
    },
    fixedBtn: 'Rejoindre',
    // Professors
    professors: {
      title: 'Nos Experts',
      subtitle: 'Identités classifiées — les mentors derrière chaque campus',
    },
    // Login
    login: {
      title: 'Connexion',
      subtitle: 'Entre ton email pour recevoir un code',
      emailPlaceholder: 'Ton email',
      sendOtp: 'ENVOYER LE CODE',
      sending: 'ENVOI...',
      otpPlaceholder: 'Code à 6 chiffres',
      verify: 'VÉRIFIER',
      verifying: 'VÉRIFICATION...',
      back: 'Retour à l\u2019accueil',
      noAccount: 'Pas encore membre ?',
      join: 'Rejoins OpenBro',
      emailLabel: 'Adresse email',
      emailExample: 'ton@email.com',
      codeSent: 'Code envoyé à',
      codeLabel: 'Code de vérification',
      resend: 'Renvoyer le code',
      changeEmail: 'Changer d\u2019email',
      sentDefault: 'Code envoyé.',
      sendError: 'Erreur lors de l\u2019envoi du code.',
      verifyError: 'Code incorrect ou expiré.',
    },
    // Dashboard
    dashboard: {
      programmes: 'Programmes',
      monkMode: 'Monk Mode',
      resources: 'Ressources',
      community: 'Communauté',
      recordings: 'Enregistrements',
      support: 'Support',
      affiliate: 'Portail Affilié',
      settings: 'Paramètres',
      logout: 'Déconnexion',
      joinMembers: 'Rejoins les membres',
      joinCommunity: 'REJOINS LA\nCOMMUNAUTÉ',
      access: 'ACCÉDER',
      welcome: 'Bienvenue',
      continueTraining: 'Continue ton entraînement',
    },
    chat: {
      howCanWeHelp: 'Comment on peut t\'aider ?',
      talkWithUs: 'Discute avec nous',
      askQuestion: 'Poser une question',
      teamCanHelp: 'L\'équipe OpenBro peut t\'aider',
      viewCourses: 'Voir les formations',
      pricingPlans: 'Tarifs & abonnement',
      joinCommunity: 'Rejoindre la communauté',
      statusOk: 'Tous les systèmes opérationnels',
      home: 'Accueil',
      messages: 'Messages',
      noMessages: 'Pas de messages',
      messagesWillAppear: 'Les messages de l\'équipe apparaîtront ici',
      openBroSupport: 'OpenBro Support',
      teamAlsoHelps: 'L\'équipe peut aussi t\'aider',
      hiMessage: 'Salut !\nComment on peut t\'aider aujourd\'hui ?',
      emailPlaceholder: 'email@exemple.com',
      messagePlaceholder: 'Pose ta question...',
      justNow: 'À l\'instant',
      onlineNow: 'En ligne',
      beforeWeStart: 'Avant de commencer...',
      yourName: 'Ton prénom',
      startChat: 'Démarrer le chat',
    },
    privacy: {
      title: 'Politique de confidentialité',
      back: 'Retour à l’accueil',
      sections: [
        { title: 'Introduction', content: 'Cette politique explique quelles informations personnelles OpenBro (« nous ») collecte quand tu visites gautbonac.com ou que tu rejoins OpenBro, et pourquoi.' },
        { title: 'Ce que nous collectons', content: 'Ton prénom et ton email (compte et connexion). Au paiement, via Stripe : ton numéro de téléphone et tes informations de facturation (nous ne voyons ni ne stockons ton numéro de carte complet). Le créneau d’appel choisi et ton fuseau horaire.' },
        { title: 'Pourquoi nous les utilisons', content: 'Pour fournir ton abonnement, planifier et passer ton appel mensuel, te donner accès à ton compte (codes de connexion), encaisser les paiements, prévenir la fraude et améliorer le site. Ton prénom, ta ville et l’heure de ton inscription apparaissent dans la notification « Vient de rejoindre » seulement si tu as écrit un prénom dans le champ facultatif du paiement.' },
        { title: 'Tes droits', content: 'Si tu résides dans l’UE ou au Royaume-Uni (RGPD), tu as un droit d’accès, de rectification, d’effacement, d’opposition, de limitation et de portabilité. Si tu résides aux États-Unis, y compris en Californie, tu peux demander l’accès, la correction ou la suppression de tes données. Écris-nous à mia@openpro.ai. Exercer ces droits ne change rien au service que tu reçois.' },
        { title: 'Conservation', content: 'Nous gardons tes données tant que ton compte est actif, puis le temps exigé par la loi (par exemple pour la comptabilité).' },
        { title: 'Emails', content: 'Nous pouvons t’écrire pour ton compte, tes appels et nos annonces. Pour ne plus recevoir les emails marketing, écris à mia@openpro.ai.' },
        { title: 'Modifications', content: 'Nous pouvons modifier cette politique. Nous te prévenons des changements importants par email.' },
        { title: 'Contact', content: 'Questions : mia@openpro.ai. En vigueur au 4 octobre 2026.' },
      ],
    },
    terms: {
      title: 'Conditions générales',
      back: 'Retour à l’accueil',
      sections: [
        { title: 'Accord', content: 'Bienvenue sur OpenBro. Le site gautbonac.com (le « Site ») et l’abonnement OpenBro sont proposés sous réserve que tu acceptes les présentes conditions (les « Conditions »). En utilisant le Site ou en t’abonnant, tu les acceptes.' },
        { title: 'Le service', content: 'OpenBro est un abonnement de mentorat : un appel privé par mois avec Gaut Bonac sur le créneau que tu réserves, un plan d’action pour les 30 jours suivants, l’accès aux campus en ligne et à une communauté privée.' },
        { title: 'Prix et paiement', content: 'Prix de lancement jusqu’au dimanche 11 octobre 2026 à 23:59 (heure de Paris) : 29 € par mois, 29 $ US par mois aux États-Unis, ou 39 $ CA par mois au Canada. Ensuite : 99 € par mois, 49 $ US ou 69 $ CA. Le prix payé à l’inscription reste le même tant que l’abonnement continue. Le prix et la devise sont affichés avant le paiement. Le paiement est traité par Stripe. Des taxes peuvent s’ajouter selon ton pays.' },
        { title: 'Renouvellement automatique et résiliation', content: 'Ton abonnement se renouvelle automatiquement chaque mois, au même prix, jusqu’à ce que tu le résilies. Tu peux résilier à tout moment en écrivant à mia@openpro.ai : la résiliation arrête les renouvellements suivants et prend effet à la fin du mois déjà payé. Nous te confirmons la résiliation par email.' },
        { title: 'Remboursements', content: 'En règle générale, les mois déjà payés ne sont pas remboursés, en raison de la nature numérique du service, sauf si la loi applicable l’exige.' },
        { title: 'Résultats', content: 'OpenBro apporte un accompagnement et des contenus éducatifs. Nous ne garantissons aucun résultat, qu’il s’agisse de revenus, de forme physique ou autre. Les résultats montrés sur le Site sont individuels et dépendent de la situation et du travail de chacun.' },
        { title: 'Confidentialité', content: 'L’utilisation du Site est aussi régie par notre politique de confidentialité.' },
        { title: 'Propriété intellectuelle', content: 'Les contenus du Service (textes, vidéos, images, logos) appartiennent à OpenBro et sont protégés par le droit d’auteur. Ils sont réservés à ton usage personnel.' },
        { title: 'Contact', content: 'Questions sur ces Conditions : mia@openpro.ai. En vigueur au 4 octobre 2026.' },
      ],
    },
  },
  en: {
    nav: {
      home: 'Home',
      courses: 'Courses',
      testimonials: 'Testimonials',
      method: 'Method',
      campus: 'Campus',
      login: 'Login',
    },
    hero: {
      brandName: 'OPENBRO · GAUT BONAC',
      headline: 'ONE MENTOR. ONE PLAN. EVERY MONTH.',
      subtitle1: 'A private call with me <strong>every month</strong>, and you leave with your actions for the next 30 days.',
      subtitle2: {
        before: 'Between calls, 6 programs to move forward on your ',
        bold1: 'BODY',
        mid1: ', your ',
        bold2: 'CONTENT',
        mid2: ' and your ',
        bold3: 'INCOME.',
      },
      cta: 'Join OpenBro',
      enrolled: 'No commitment · Cancel anytime',
    },
    stats: [
      { value: '1', label: 'Private call a month' },
      { value: '6', label: 'Full programs' },
      { value: '100+', label: 'Lessons' },
    ],
    takeAction: {
      label: 'TAKE ACTION',
      title: 'You Don’t Need More Content',
      paragraphs: [
        { text: 'You need <strong>someone to tell you what to do next</strong>, and to hold you to it the month after.' },
        { text: 'Every month we get on a call. You leave with <mark>a 30-day action plan.</mark>' },
        { text: 'Between calls: strength, nutrition, e-commerce, filming, editing, AI. <strong>Everything you need to follow through.</strong>' },
        { text: 'The programs are taught by <strong>people who actually do it</strong>, not theorists.' },
        { text: 'And a <mark>private community</mark> of people moving forward, so you stop doing it alone.' },
      ],
    },
    campuses: {
      label: '6 PROGRAMS INCLUDED',
      title: 'What You’ll Learn',
      items: [
        { name: 'Strength & Discipline', description: 'Beginner to intermediate: <strong>technique, programming, progression.</strong> And discipline that lasts beyond the gym.' },
        { name: 'E-commerce & Social media', description: '<strong>Launch your store and grow your audience.</strong> Find a product, sell it, turn followers into customers.' },
        { name: 'Filming', description: 'Shoot like a pro <strong>with an iPhone.</strong> Framing, light, sound: everything that makes a video watchable.' },
        { name: 'Video editing', description: 'CapCut and beyond: <strong>pacing, hooks, pro finish.</strong> Videos people watch to the end.' },
        { name: 'AI & Automation', description: '<strong>Use AI every day</strong> and learn to sell AI services. Save time first, then make money.' },
        { name: 'Nutrition & Performance', description: 'Food, supplements and <strong>a simple system you can keep.</strong> More energy, better recovery.' },
      ],
    },
    empowering: {
      label: 'OPENBRO',
      title: 'You’re Not Doing It Alone Anymore',
      testimonialName: '',
      testimonialEarning: '',
      description: 'At OpenBro, you learn <strong>the skills that actually matter</strong>, with a private call every month and <mark>a community of people who take action.</mark>',
    },
    features: [
      {
        title: 'Discipline Is Freedom',
        points: ['Structured strength programs and daily routines.', 'Habit and streak tracking in your member area.', 'Nutrition built for performance, simple to keep.'],
      },
      {
        title: 'Content That Hooks',
        points: ['Filming and editing, from script to publish.', 'Short formats that hold attention from the first second.', 'Monetize your audience with e-commerce.'],
      },
      {
        title: 'AI & Automation',
        points: ['Use AI to save time on your business and content.', 'Learn to sell AI services.', 'Ask your questions in the private community.'],
      },
    ],
    twoPaths: {
      label: 'CHOOSE YOUR PATH',
      title: 'Two Paths Ahead Of You',
      path1: {
        price: '€0',
        description: 'You keep scrolling <strong>without changing anything.</strong> Same body, same routine, same results. <strong>Time passes</strong> and nothing moves.',
        cta: 'Stay a spectator',
      },
      path2: {
        price: '€49/month',
        description: 'A private call every month, <strong>a 30-day plan</strong> and 6 programs to carry it out. No commitment, <mark>cancel anytime.</mark>',
        cta: 'Join OpenBro',
      },
    },
    studentWins: {
      label: 'MEMBER RESULTS',
      title: 'They Took Action',
      subtitle: 'Screenshots sent by members.',
      subtitleBold: 'The plan comes from the call. <mark>The work comes from them.</mark>',
    },
    lastChance: {
      title: 'In 30 Days, You’ll Be Somewhere',
      cta: 'Join OpenBro',
      subtitle: 'Might as well be with a plan.',
    },
    faq: {
      title: 'Frequently Asked Questions',
      disclaimer1: 'All content taught at OpenBro is for educational purposes. It is up to each member to apply it and put in the work.',
      disclaimer2: 'OpenBro does not guarantee any physical or financial result.',
      questions: [
        { question: 'Who is it for?', answer: 'For you if you want to move forward on your business, money, body or personal life, and you’re ready to act. If you’re looking for a magic formula, you just found it.' },
        { question: 'How does the call work?', answer: 'You pick your slot before paying. I call you on the number you give at checkout. We look at your situation and you leave with your priorities for the month.' },
        { question: 'I’m a beginner. Is that a problem?', answer: 'No. The programs start from zero, and the call starts from your situation, not a standard plan.' },
        { question: 'Do I need equipment?', answer: 'No. The programs work at the gym or at home. For video, a smartphone is enough to start.' },
        { question: 'How much time a day?', answer: 'It depends on your plan. We set it during the call around the time you actually have, not the time you wish you had.' },
        { question: 'What happens after I pay?', answer: 'You activate your account with your first name and email. You log in with a code sent by email, and you get access to everything: programs, tracking, community.' },
        { question: 'Can I stop whenever I want?', answer: 'Yes. No commitment, cancel whenever you want. Months already paid are not refunded.' },
        { question: 'Still have a question?', answer: 'Message us through the chat at the bottom right, or email contact@openroom.com.' },
      ],
    },
    customPlatform: {
      title: 'Your Member\\nArea',
      description: 'Programs, habit tracking and progress, <mark>in one place, on phone and computer.</mark>',
    },
    urgency: {
      offer: 'OPENBRO',
      price: '€49/MONTH',
      wontLast: 'ONE PRIVATE CALL EVERY MONTH',
      discount: '6 PROGRAMS',
      priceWillIncrease: 'PRIVATE COMMUNITY',
      members: 'NO COMMITMENT · CANCEL ANYTIME',
    },
    landing: {
      tagline: 'Something is coming...',
      prompt: 'Enter your email to be the first to know',
      emailPlaceholder: 'yourbest@email.com',
      cta: 'ENTER',
      sending: '...',
      successMessage: "You're on the list.",
      successSub: "We'll be in touch soon.",
      invalidEmail: 'Invalid email',
      networkError: 'Connection error',
      footerHint: 'OPENBRO 2025',
    },
    fixedBtn: 'Join',
    professors: {
      title: 'Our Experts',
      subtitle: 'Classified identities \u2014 the mentors behind each campus',
    },
    login: {
      title: 'Login',
      subtitle: 'Enter your email to receive a code',
      emailPlaceholder: 'Your email',
      sendOtp: 'SEND CODE',
      sending: 'SENDING...',
      otpPlaceholder: '6-digit code',
      verify: 'VERIFY',
      verifying: 'VERIFYING...',
      back: 'Back to home',
      noAccount: 'Not a member yet?',
      join: 'Join OpenBro',
      emailLabel: 'Email address',
      emailExample: 'you@email.com',
      codeSent: 'Code sent to',
      codeLabel: 'Verification code',
      resend: 'Resend code',
      changeEmail: 'Change email',
      sentDefault: 'Code sent.',
      sendError: 'We couldn\u2019t send the code. Please try again.',
      verifyError: 'Wrong or expired code.',
    },
    dashboard: {
      programmes: 'Programs',
      monkMode: 'Monk Mode',
      resources: 'Resources',
      community: 'Community',
      recordings: 'Recordings',
      support: 'Support',
      affiliate: 'Affiliate Portal',
      settings: 'Settings',
      logout: 'Log Out',
      joinMembers: 'Join the members',
      joinCommunity: 'JOIN THE\nCOMMUNITY',
      access: 'ACCESS',
      welcome: 'Welcome',
      continueTraining: 'Continue your training',
    },
    chat: {
      howCanWeHelp: 'How can we help?',
      talkWithUs: 'Talk with us',
      askQuestion: 'Ask a question',
      teamCanHelp: 'OpenBro team can help',
      viewCourses: 'View courses',
      pricingPlans: 'Pricing & plans',
      joinCommunity: 'Join the community',
      statusOk: 'All systems operational',
      home: 'Home',
      messages: 'Messages',
      noMessages: 'No messages',
      messagesWillAppear: 'Messages from the team will be shown here',
      openBroSupport: 'OpenBro Support',
      teamAlsoHelps: 'The team can also help',
      hiMessage: 'Hi!\nHow can we help you today?',
      emailPlaceholder: 'email@example.com',
      messagePlaceholder: 'Ask a question...',
      justNow: 'Just now',
      onlineNow: 'Online',
      beforeWeStart: 'Before we start...',
      yourName: 'Your name',
      startChat: 'Start chat',
    },
    privacy: {
      title: 'Privacy Policy',
      back: 'Back to home',
      sections: [
        { title: 'Introduction', content: 'This Privacy Policy explains what personal information OpenBro (“we”) collects when you visit gautbonac.com or join OpenBro, and why we collect it.' },
        { title: 'Information we collect', content: 'Your first name and email address (account and login). At checkout, through Stripe: your phone number and billing details (we never see or store your full card number). The call time you book and your time zone.' },
        { title: 'How we use it', content: 'To provide your membership, schedule and make your monthly call, give you access to your account (login codes), process payments, prevent fraud and improve the site. Your first name, city and time of joining appear in the “Just joined” notification only if you typed a first name in the optional checkout field.' },
        { title: 'Your rights', content: 'If you live in the EU or the UK (GDPR), you have the right to access, correct, delete, object to, restrict and port your data. If you live in the United States, including California, you can ask us to access, correct or delete your personal information. Email us at mia@openpro.ai. Using these rights does not change the service you receive.' },
        { title: 'Retention', content: 'We keep your data while your account is active, then for as long as the law requires (for example, for accounting).' },
        { title: 'Emails', content: 'We may email you about your account, your calls and our announcements. To stop marketing emails, write to mia@openpro.ai.' },
        { title: 'Changes', content: 'We may update this policy. We will email you about significant changes.' },
        { title: 'Contact', content: 'Questions: mia@openpro.ai. Effective October 4, 2026.' },
      ],
    },
    terms: {
      title: 'Terms & Conditions',
      back: 'Back to home',
      sections: [
        { title: 'Agreement', content: 'Welcome to OpenBro. The gautbonac.com website (the “Site”) and the OpenBro membership are offered to you on the condition that you accept these terms (the “Terms”). By using the Site or subscribing, you agree to them.' },
        { title: 'The service', content: 'OpenBro is a mentorship membership: one private call a month with Gaut Bonac at the time you book, an action plan for the next 30 days, access to the online campuses and to a private community.' },
        { title: 'Price and payment', content: 'Launch price until Sunday, October 11, 2026, 11:59 PM (Paris time): $29 (USD) per month in the United States, CA$39 per month in Canada, or €29 per month elsewhere. After that: $49, CA$69 or €99 per month. The price you pay when you join stays the same as long as your subscription continues. The price and currency are shown before you pay. Payments are processed by Stripe. Taxes may apply depending on where you live.' },
        { title: 'Automatic renewal and cancellation', content: 'Your membership renews automatically every month at the same price until you cancel. You can cancel at any time by emailing mia@openpro.ai: cancellation stops all future renewals and takes effect at the end of the month you already paid for. We confirm your cancellation by email.' },
        { title: 'Refunds', content: 'As a general rule, months already paid are not refunded, due to the digital nature of the service, except where the law requires it.' },
        { title: 'Results', content: 'OpenBro provides mentorship and educational content. We do not guarantee any result, whether income, fitness or anything else. Results shown on the Site are individual and depend on each person’s situation and effort.' },
        { title: 'Privacy', content: 'Your use of the Site is also governed by our Privacy Policy.' },
        { title: 'Intellectual property', content: 'All content in the Service (text, videos, images, logos) belongs to OpenBro and is protected by copyright. It is for your personal use only.' },
        { title: 'Contact', content: 'Questions about these Terms: mia@openpro.ai. Effective October 4, 2026.' },
      ],
    },
  },
};

export default t;
